var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 603.87 261.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43{stroke-width:0px;}.cls-2,.cls-39{fill:#414042;}.cls-3{fill:url(#New_Gradient_Swatch_4);}.cls-4{fill:url(#New_Gradient_Swatch_5);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#New_Gradient_Swatch_2);}.cls-7,.cls-8,.cls-39,.cls-42{mix-blend-mode:multiply;}.cls-7,.cls-40{fill:#d1d3d4;}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#New_Gradient_Swatch_5-2);}.cls-10{fill:url(#New_Gradient_Swatch_3-2);}.cls-11{fill:url(#New_Gradient_Swatch_2-2);}.cls-12{fill:url(#New_Gradient_Swatch_4-2);}.cls-13{fill:url(#linear-gradient);}.cls-14{fill:url(#radial-gradient);}.cls-15{fill:#ef4136;}.cls-16{fill:#6d6e71;}.cls-17{fill:#f15a29;}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:#bcbec0;}.cls-26{fill:#000;}.cls-27{fill:#a7a9ac;}.cls-28{fill:url(#radial-gradient-2);}.cls-29{fill:#be1e2d;}.cls-30{fill:url(#linear-gradient-4);}.cls-31{fill:url(#linear-gradient-2);}.cls-32{fill:url(#linear-gradient-3);}.cls-33{fill:url(#linear-gradient-9);}.cls-34{fill:url(#linear-gradient-7);}.cls-35{fill:url(#linear-gradient-5);}.cls-36{fill:url(#linear-gradient-6);}.cls-37,.cls-42{fill:#939598;}.cls-44{isolation:isolate;}.cls-38{opacity:.4;}.cls-38,.cls-41{fill:#fff;}.cls-43{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 117.85,
    y1: 261.73,
    x2: 117.85,
    y2: 206.66,
    gradientTransform: "translate(5.33 -2.74) rotate(1.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 117.85,
    y1: 261.62,
    x2: 117.85,
    y2: 184.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 117.85,
    y1: 191.17,
    x2: 117.85,
    y2: 254.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 117.85,
    y1: 198.63,
    x2: 117.85,
    y2: 247.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -192.82,
    cy: 86.02,
    fx: -192.82,
    fy: 86.02,
    r: 26.41,
    gradientTransform: "translate(278.41 151.21) scale(.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 117.85,
    y1: 228.36,
    x2: 117.85,
    y2: 216.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 482.02,
    x2: 482.02,
    gradientTransform: "translate(5.44 -11.4) rotate(1.36)",
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 482.02,
    x2: 482.02,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 482.02,
    x2: 482.02,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 482.02,
    x2: 482.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 244.52,
    fx: 244.52,
    r: 26.41,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 482.02,
    y1: 228.36,
    x2: 482.02,
    y2: 216.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 306.4,
    y1: -0.68,
    x2: 306.4,
    y2: 229.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#d5d7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 482.02,
    y1: 154.51,
    x2: 482.02,
    y2: 234.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f2f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#e3e3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#cdced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b0b2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 117.85,
    x2: 117.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 109.91,
    y1: 110.66,
    x2: 109.91,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#276f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2a6862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 149.95,
    y1: 125.31,
    x2: 149.95,
    y2: 112.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#535254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#828385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 149.71,
    y1: 122.22,
    x2: 149.71,
    y2: 115.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 3487.09,
    y1: -95.63,
    x2: 3487.09,
    y2: -108.22,
    gradientTransform: "translate(-3276.87 221.2)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 3487.09,
    y1: -98.72,
    x2: 3487.09,
    y2: -105.03,
    gradientTransform: "translate(-3276.87 221.2)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 19.08,
    y1: 139.82,
    x2: 19.08,
    y2: 160.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 594.25,
    y1: 116.67,
    x2: 594.25,
    y2: 179.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 595.5,
    y1: 160.91,
    x2: 595.5,
    y2: 173.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 595.5,
    y1: 144.44,
    x2: 595.5,
    y2: 156.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 281,
    y1: 110.63,
    x2: 281,
    y2: 43.71,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 471.29,
    y1: 110.63,
    x2: 471.29,
    y2: 43.71,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 8.94,
    y: 155.28,
    width: 578.53,
    height: 66.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 117.85,
    cy: 216.91,
    rx: 62.42,
    ry: 13.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M482.02,228.42c-26.01,0-48.77-2.58-61.26-6.45,5.58,6.11,30.88,10.72,61.26,10.72s55.68-4.61,61.26-10.72c-12.49,3.86-35.25,6.45-61.26,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M426.34,232.01h0c-1.92-.89-2.77-3.19-1.88-5.11l3.23-6.99c.89-1.92,3.19-2.77,5.11-1.88h0c1.92.89,2.77,3.19,1.88,5.11l-3.23,6.99c-.89,1.92-3.19,2.77-5.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M537.7,232.01h0c1.92-.89,2.77-3.19,1.88-5.11l-3.23-6.99c-.89-1.92-3.19-2.77-5.11-1.88h0c-1.92.89-2.77,3.19-1.88,5.11l3.23,6.99c.89,1.92,3.19,2.77,5.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M165.27,201.63s2.48,9.97,2.54,19.59c.06,9.62-1.55,21.12-.99,21.84.56.72,6.58-18.08,7.01-26.76.43-8.68-7.01-31.15-8.56-14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M530.18,201.63s2.48,9.97,2.54,19.59-1.55,21.12-.99,21.84,6.58-18.08,7.01-26.76-7.01-31.15-8.56-14.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.85,
    cy: 222.84,
    r: 14.85,
    transform: "translate(-5.26 2.86) rotate(-1.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M117.85,184.82c-21,0-38.02,17.02-38.02,38.02s17.03,38.02,38.02,38.02,38.02-17.02,38.02-38.02-17.02-38.02-38.02-38.02ZM117.85,244.35c-11.88,0-21.51-9.63-21.51-21.51s9.63-21.51,21.51-21.51,21.51,9.63,21.51,21.51-9.63,21.51-21.51,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.17,228.17c.03-.2.27-.31.52-.27l3.42.61c.22-1.51.36-3.05.4-4.61h-3.47c-.26,0-.47-.16-.47-.35v-1.42c0-.2.21-.35.47-.35h3.47c-.04-1.56-.18-3.1-.4-4.61l-3.42.6c-.25.05-.49-.07-.52-.26l-.25-1.4c-.03-.19.15-.38.4-.43l3.43-.6c-.31-1.52-.71-3.02-1.19-4.47l-3.27,1.19c-.24.09-.49.01-.56-.17l-.48-1.34c-.07-.19.07-.4.32-.49l3.27-1.19c-.57-1.44-1.23-2.84-1.96-4.19l-3.01,1.74c-.22.13-.48.1-.58-.07l-.71-1.23c-.1-.17,0-.41.23-.54l3.01-1.73c-.81-1.32-1.7-2.58-2.65-3.79l-2.66,2.23c-.2.16-.46.18-.59.03l-.92-1.09c-.13-.15-.06-.4.13-.57l2.66-2.23c-1.03-1.15-2.12-2.25-3.27-3.27l-2.23,2.66c-.17.2-.42.26-.57.13l-1.09-.91c-.15-.13-.13-.39.03-.59l2.23-2.66c-1.21-.96-2.47-1.85-3.79-2.65l-1.74,3.01c-.13.22-.37.33-.54.23l-1.23-.71c-.17-.1-.2-.36-.07-.58l1.74-3.01c-1.35-.73-2.75-1.38-4.19-1.96l-1.19,3.27c-.08.24-.3.39-.48.32l-1.34-.48c-.19-.07-.26-.32-.17-.56l1.19-3.27c-1.45-.48-2.95-.88-4.47-1.2l-.6,3.43c-.04.26-.24.43-.43.4l-1.4-.24c-.19-.04-.31-.27-.26-.52l.6-3.42c-1.51-.22-3.05-.36-4.61-.4v3.47c0,.26-.16.47-.35.47h-1.42c-.2,0-.35-.21-.35-.47v-3.47c-1.56.04-3.1.18-4.61.4l.6,3.42c.04.26-.07.49-.26.52l-1.41.25c-.19.04-.38-.14-.43-.4l-.6-3.43c-1.52.32-3.01.71-4.47,1.2l1.19,3.27c.09.24.01.5-.17.56l-1.34.49c-.18.07-.4-.08-.49-.32l-1.19-3.27c-1.44.57-2.84,1.22-4.19,1.95l1.74,3.01c.13.22.1.49-.07.58l-1.23.71c-.17.1-.41,0-.54-.23l-1.74-3.01c-1.32.81-2.58,1.7-3.79,2.65l2.23,2.66c.17.2.18.46.03.59l-1.09.91c-.15.12-.4.06-.57-.13l-2.23-2.66c-1.15,1.02-2.24,2.12-3.27,3.27l2.66,2.23c.2.17.26.42.14.57l-.92,1.09c-.13.15-.39.13-.58-.03l-2.66-2.23c-.96,1.21-1.84,2.47-2.65,3.78l3.01,1.74c.22.13.33.38.23.54l-.71,1.23c-.1.17-.36.2-.58.07l-3.01-1.74c-.73,1.36-1.38,2.75-1.96,4.19l3.27,1.19c.24.09.39.3.32.49l-.49,1.34c-.07.18-.32.26-.56.17l-3.27-1.19c-.49,1.45-.88,2.94-1.19,4.47l3.42.6c.26.04.43.24.4.43l-.25,1.4c-.03.19-.27.31-.52.27l-3.42-.61c-.22,1.51-.36,3.05-.4,4.61h3.47c.26,0,.47.16.47.35v1.42c0,.19-.21.35-.47.35h-3.47c.04,1.56.18,3.09.4,4.6l3.42-.6c.26-.04.49.08.52.27l.25,1.4c.03.19-.15.38-.4.43l-3.42.6c.31,1.52.71,3.02,1.19,4.46l3.27-1.19c.24-.09.5-.01.56.17l.49,1.34c.07.18-.08.4-.32.49l-3.27,1.19c.57,1.44,1.22,2.84,1.96,4.19l3.01-1.74c.23-.13.49-.1.58.07l.71,1.23c.1.17,0,.41-.23.54l-3.01,1.74c.81,1.32,1.7,2.58,2.65,3.78l2.66-2.23c.2-.17.46-.18.58-.03l.92,1.09c.12.15.06.4-.14.57l-2.66,2.23c1.02,1.15,2.12,2.25,3.27,3.27l2.23-2.65c.17-.2.42-.26.57-.14l1.09.91c.15.12.14.39-.03.59l-2.23,2.66c1.21.95,2.47,1.84,3.79,2.65l1.74-3.01c.13-.22.37-.33.54-.23l1.23.71c.17.1.2.36.07.58l-1.74,3.01c1.35.73,2.75,1.39,4.19,1.96l1.19-3.27c.09-.25.31-.39.49-.32l1.34.49c.19.07.26.32.17.56l-1.19,3.27c1.45.48,2.94.89,4.47,1.19l.6-3.42c.04-.26.24-.44.42-.41l1.4.25c.19.04.31.27.27.52l-.6,3.42c1.51.22,3.05.35,4.61.4v-3.47c0-.26.15-.46.35-.46h1.43c.19,0,.35.21.35.46v3.47c1.56-.04,3.1-.18,4.61-.4l-.6-3.42c-.04-.26.07-.49.26-.53l1.4-.25c.19-.03.38.15.43.41l.6,3.43c1.52-.31,3.01-.71,4.47-1.19l-1.19-3.27c-.09-.25-.01-.49.17-.56l1.33-.49c.19-.07.41.08.49.32l1.19,3.27c1.44-.57,2.84-1.23,4.19-1.96l-1.74-3.01c-.13-.23-.1-.49.07-.58l1.23-.71c.17-.1.41,0,.54.23l1.74,3.01c1.32-.81,2.58-1.7,3.79-2.65l-2.23-2.66c-.17-.2-.18-.46-.04-.59l1.09-.91c.15-.13.41-.06.57.14l2.23,2.65c1.15-1.02,2.25-2.12,3.27-3.27l-2.66-2.23c-.2-.17-.26-.42-.13-.57l.91-1.09c.13-.15.39-.14.59.03l2.66,2.23c.96-1.21,1.85-2.47,2.65-3.78l-3.01-1.74c-.23-.13-.32-.37-.23-.54l.71-1.23c.1-.17.36-.21.58-.07l3.01,1.74c.73-1.35,1.38-2.75,1.96-4.19l-3.27-1.19c-.25-.09-.39-.31-.32-.49l.48-1.34c.07-.18.32-.26.56-.17l3.27,1.19c.48-1.45.88-2.95,1.19-4.47l-3.43-.61c-.25-.05-.43-.24-.4-.43l.25-1.4ZM117.85,244.35c-11.88,0-21.51-9.63-21.51-21.51s9.63-21.51,21.51-21.51,21.51,9.63,21.51,21.51-9.63,21.51-21.51,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.85,190.98c-17.6,0-31.86,14.27-31.86,31.86s14.26,31.86,31.86,31.86,31.86-14.26,31.86-31.86-14.26-31.86-31.86-31.86ZM117.85,243.35c-11.33,0-20.51-9.18-20.51-20.51s9.18-20.51,20.51-20.51,20.51,9.18,20.51,20.51-9.18,20.51-20.51,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M117.85,198.39c-13.51,0-24.45,10.95-24.45,24.45s10.95,24.45,24.45,24.45,24.45-10.95,24.45-24.45-10.95-24.45-24.45-24.45ZM117.85,240.64c-9.83,0-17.8-7.97-17.8-17.8s7.97-17.8,17.8-17.8,17.8,7.97,17.8,17.8-7.97,17.8-17.8,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M127.24,228.26c1.48-2.57,5.72-3.16,11.09-2.01.18-1.11.3-2.25.3-3.41s-.12-2.3-.3-3.41c-5.37,1.15-9.61.56-11.09-2.01-1.49-2.57.13-6.54,3.82-10.62-1.75-1.45-3.76-2.59-5.93-3.4-1.69,5.22-4.32,8.6-7.29,8.6s-5.6-3.38-7.29-8.6c-2.17.81-4.17,1.95-5.93,3.4,3.69,4.08,5.3,8.05,3.82,10.62-1.48,2.57-5.72,3.16-11.09,2.01-.18,1.11-.3,2.25-.3,3.41s.12,2.3.3,3.41c5.37-1.15,9.61-.56,11.09,2.01,1.48,2.57-.13,6.54-3.82,10.62,1.75,1.45,3.76,2.59,5.93,3.4,1.69-5.22,4.32-8.6,7.29-8.6s5.6,3.38,7.29,8.6c2.17-.81,4.17-1.95,5.93-3.4-3.69-4.08-5.3-8.05-3.82-10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M139.73,224.88c.07-.67.1-1.35.1-2.04s-.04-1.37-.1-2.04c-.6-6.53-4.07-12.22-9.12-15.84-.03-.02-.06-.05-.09-.07-.53-.37-1.07-.72-1.63-1.04-.02,0-.03-.02-.05-.03-3.24-1.87-6.98-2.96-10.99-2.96s-7.75,1.09-10.99,2.96c-.02,0-.03.02-.05.03-.56.33-1.1.67-1.63,1.04-.03.02-.06.05-.09.07-.52.37-1.02.76-1.5,1.17,0,0,0,0,0,0h0c-4.23,3.62-7.08,8.8-7.62,14.67-.07.67-.1,1.35-.1,2.04s.04,1.37.1,2.04c.6,6.53,4.07,12.22,9.12,15.84.03.02.06.05.09.07.53.37,1.07.72,1.63,1.05.02,0,.03.02.05.03,3.24,1.87,6.98,2.96,10.99,2.96s7.75-1.09,10.99-2.96c.02,0,.03-.02.05-.03.56-.33,1.1-.67,1.63-1.04.03-.02.06-.05.09-.07.52-.37,1.02-.76,1.5-1.17h0c4.23-3.62,7.08-8.81,7.62-14.67ZM137.62,219.4c-5.55,1.55-10.06,1.21-11.52-1.32-1.46-2.54.5-6.62,4.62-10.65,3.57,2.99,6.07,7.19,6.9,11.98ZM124.76,204c-1.43,5.58-3.98,9.32-6.91,9.32s-5.48-3.74-6.91-9.32c2.16-.79,4.48-1.25,6.91-1.25s4.75.45,6.91,1.25ZM104.98,207.43c4.13,4.03,6.09,8.12,4.62,10.65-1.46,2.53-5.98,2.88-11.52,1.32.83-4.78,3.33-8.99,6.9-11.98ZM98.08,226.28c5.55-1.55,10.06-1.21,11.52,1.32,1.46,2.54-.5,6.62-4.62,10.65-3.57-2.99-6.07-7.19-6.9-11.98ZM110.94,241.68c1.43-5.58,3.98-9.32,6.91-9.32s5.48,3.74,6.91,9.32c-2.16.79-4.48,1.25-6.91,1.25s-4.75-.45-6.91-1.25ZM126.09,227.6c1.46-2.53,5.98-2.88,11.52-1.32-.83,4.78-3.33,8.99-6.9,11.98-4.13-4.03-6.09-8.12-4.62-10.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 117.85,
    cy: 222.84,
    r: 7.92,
    transform: "translate(-12.13 6.85) rotate(-3.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M123.45,222.84c0,3.09-2.51,5.6-5.6,5.6s-5.6-2.51-5.6-5.6,2.51-5.6,5.6-5.6,5.6,2.51,5.6,5.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 117.85,
    cy: 222.84,
    r: 4.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 482.02,
    cy: 222.84,
    r: 14.85,
    transform: "translate(-5.16 11.53) rotate(-1.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M482.02,184.82c-21,0-38.02,17.02-38.02,38.02s17.03,38.02,38.02,38.02,38.02-17.02,38.02-38.02-17.02-38.02-38.02-38.02ZM482.02,244.35c-11.88,0-21.51-9.63-21.51-21.51s9.63-21.51,21.51-21.51,21.51,9.63,21.51,21.51-9.63,21.51-21.51,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M516.35,228.17c.04-.2.27-.31.52-.27l3.42.61c.22-1.51.36-3.05.4-4.61h-3.47c-.26,0-.47-.16-.47-.35v-1.42c0-.2.21-.35.47-.35h3.47c-.04-1.56-.18-3.1-.4-4.61l-3.42.6c-.25.05-.49-.07-.52-.26l-.25-1.4c-.03-.19.15-.38.4-.43l3.43-.6c-.31-1.52-.71-3.02-1.19-4.47l-3.27,1.19c-.24.09-.49.01-.56-.17l-.48-1.34c-.07-.19.07-.4.32-.49l3.27-1.19c-.57-1.44-1.23-2.84-1.96-4.19l-3.01,1.74c-.22.13-.48.1-.58-.07l-.71-1.23c-.1-.17,0-.41.23-.54l3.01-1.73c-.81-1.32-1.7-2.58-2.65-3.79l-2.66,2.23c-.2.16-.46.18-.59.03l-.92-1.09c-.13-.15-.06-.4.13-.57l2.66-2.23c-1.03-1.15-2.12-2.25-3.27-3.27l-2.23,2.66c-.17.2-.42.26-.57.13l-1.09-.91c-.15-.13-.13-.39.03-.59l2.23-2.66c-1.21-.96-2.47-1.85-3.79-2.65l-1.74,3.01c-.13.22-.37.33-.54.23l-1.23-.71c-.17-.1-.2-.36-.07-.58l1.74-3.01c-1.35-.73-2.75-1.38-4.19-1.96l-1.19,3.27c-.08.24-.3.39-.48.32l-1.34-.48c-.19-.07-.26-.32-.17-.56l1.19-3.27c-1.45-.48-2.95-.88-4.47-1.2l-.6,3.43c-.04.26-.24.43-.43.4l-1.4-.24c-.19-.04-.31-.27-.26-.52l.6-3.42c-1.51-.22-3.05-.36-4.61-.4v3.47c0,.26-.16.47-.35.47h-1.42c-.2,0-.35-.21-.35-.47v-3.47c-1.56.04-3.1.18-4.61.4l.6,3.42c.04.26-.07.49-.26.52l-1.41.25c-.19.04-.38-.14-.43-.4l-.6-3.43c-1.52.32-3.01.71-4.47,1.2l1.19,3.27c.09.24.01.5-.17.56l-1.34.49c-.18.07-.4-.08-.49-.32l-1.19-3.27c-1.44.57-2.84,1.22-4.19,1.95l1.74,3.01c.13.22.1.49-.07.58l-1.23.71c-.17.1-.41,0-.54-.23l-1.74-3.01c-1.32.81-2.58,1.7-3.79,2.65l2.23,2.66c.17.2.18.46.03.59l-1.09.91c-.15.12-.4.06-.57-.13l-2.23-2.66c-1.15,1.02-2.24,2.12-3.27,3.27l2.66,2.23c.2.17.26.42.14.57l-.92,1.09c-.13.15-.39.13-.58-.03l-2.66-2.23c-.96,1.21-1.84,2.47-2.65,3.78l3.01,1.74c.22.13.33.38.23.54l-.71,1.23c-.1.17-.36.2-.58.07l-3.01-1.74c-.73,1.36-1.38,2.75-1.96,4.19l3.27,1.19c.24.09.39.3.32.49l-.49,1.34c-.07.18-.32.26-.56.17l-3.27-1.19c-.49,1.45-.88,2.94-1.19,4.47l3.42.6c.26.04.43.24.4.43l-.25,1.4c-.03.19-.27.31-.52.27l-3.42-.61c-.22,1.51-.36,3.05-.4,4.61h3.47c.26,0,.47.16.47.35v1.42c0,.19-.21.35-.47.35h-3.47c.04,1.56.18,3.09.4,4.6l3.42-.6c.26-.04.49.08.52.27l.25,1.4c.03.19-.15.38-.4.43l-3.42.6c.31,1.52.71,3.02,1.19,4.46l3.27-1.19c.24-.09.5-.01.56.17l.49,1.34c.07.18-.08.4-.32.49l-3.27,1.19c.57,1.44,1.22,2.84,1.96,4.19l3.01-1.74c.23-.13.49-.1.58.07l.71,1.23c.1.17,0,.41-.23.54l-3.01,1.74c.81,1.32,1.7,2.58,2.65,3.78l2.66-2.23c.2-.17.46-.18.58-.03l.92,1.09c.12.15.06.4-.14.57l-2.66,2.23c1.02,1.15,2.12,2.25,3.27,3.27l2.23-2.65c.17-.2.42-.26.57-.14l1.09.91c.15.12.14.39-.03.59l-2.23,2.66c1.21.95,2.47,1.84,3.79,2.65l1.74-3.01c.13-.22.37-.33.54-.23l1.23.71c.17.1.2.36.07.58l-1.74,3.01c1.35.73,2.75,1.39,4.19,1.96l1.19-3.27c.09-.25.31-.39.49-.32l1.34.49c.19.07.26.32.17.56l-1.19,3.27c1.45.48,2.94.89,4.47,1.19l.6-3.42c.04-.26.24-.44.42-.41l1.4.25c.19.04.31.27.27.52l-.6,3.42c1.51.22,3.05.35,4.61.4v-3.47c0-.26.15-.46.35-.46h1.43c.19,0,.35.21.35.46v3.47c1.56-.04,3.1-.18,4.61-.4l-.6-3.42c-.04-.26.07-.49.26-.53l1.4-.25c.19-.03.38.15.43.41l.6,3.43c1.52-.31,3.01-.71,4.47-1.19l-1.19-3.27c-.09-.25-.02-.49.17-.56l1.33-.49c.19-.07.41.08.49.32l1.19,3.27c1.44-.57,2.84-1.23,4.19-1.96l-1.74-3.01c-.13-.23-.1-.49.07-.58l1.23-.71c.17-.1.41,0,.54.23l1.74,3.01c1.32-.81,2.58-1.7,3.79-2.65l-2.23-2.66c-.17-.2-.18-.46-.04-.59l1.09-.91c.15-.13.41-.06.57.14l2.23,2.65c1.15-1.02,2.25-2.12,3.27-3.27l-2.66-2.23c-.2-.17-.26-.42-.13-.57l.91-1.09c.13-.15.39-.14.59.03l2.66,2.23c.96-1.21,1.85-2.47,2.65-3.78l-3.01-1.74c-.23-.13-.32-.37-.23-.54l.71-1.23c.1-.17.36-.21.58-.07l3.01,1.74c.73-1.35,1.38-2.75,1.96-4.19l-3.27-1.19c-.25-.09-.39-.31-.32-.49l.48-1.34c.07-.18.32-.26.56-.17l3.27,1.19c.48-1.45.88-2.95,1.19-4.47l-3.43-.61c-.25-.05-.43-.24-.4-.43l.25-1.4ZM482.02,244.35c-11.88,0-21.51-9.63-21.51-21.51s9.63-21.51,21.51-21.51,21.51,9.63,21.51,21.51-9.63,21.51-21.51,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M482.02,190.98c-17.6,0-31.86,14.27-31.86,31.86s14.26,31.86,31.86,31.86,31.86-14.26,31.86-31.86-14.26-31.86-31.86-31.86ZM482.02,243.35c-11.33,0-20.51-9.18-20.51-20.51s9.18-20.51,20.51-20.51,20.51,9.18,20.51,20.51-9.18,20.51-20.51,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M482.02,198.39c-13.51,0-24.45,10.95-24.45,24.45s10.95,24.45,24.45,24.45,24.45-10.95,24.45-24.45-10.95-24.45-24.45-24.45ZM482.02,240.64c-9.83,0-17.8-7.97-17.8-17.8s7.97-17.8,17.8-17.8,17.8,7.97,17.8,17.8-7.97,17.8-17.8,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M491.41,228.26c1.48-2.57,5.72-3.16,11.09-2.01.18-1.11.3-2.25.3-3.41s-.12-2.3-.3-3.41c-5.37,1.15-9.61.56-11.09-2.01-1.49-2.57.13-6.54,3.82-10.62-1.75-1.45-3.76-2.59-5.93-3.4-1.69,5.22-4.32,8.6-7.29,8.6s-5.6-3.38-7.29-8.6c-2.17.81-4.17,1.95-5.93,3.4,3.69,4.08,5.3,8.05,3.82,10.62-1.48,2.57-5.72,3.16-11.09,2.01-.18,1.11-.3,2.25-.3,3.41s.12,2.3.3,3.41c5.37-1.15,9.61-.56,11.09,2.01,1.49,2.57-.13,6.54-3.82,10.62,1.75,1.45,3.76,2.59,5.93,3.4,1.69-5.22,4.32-8.6,7.29-8.6s5.6,3.38,7.29,8.6c2.17-.81,4.17-1.95,5.93-3.4-3.69-4.08-5.3-8.05-3.82-10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M503.9,224.88c.07-.67.1-1.35.1-2.04s-.04-1.37-.1-2.04c-.6-6.53-4.07-12.22-9.12-15.84-.03-.02-.06-.05-.09-.07-.53-.37-1.07-.72-1.63-1.04-.02,0-.03-.02-.05-.03-3.24-1.87-6.98-2.96-10.99-2.96s-7.75,1.09-10.99,2.96c-.02,0-.03.02-.05.03-.56.33-1.1.67-1.63,1.04-.03.02-.06.05-.09.07-.52.37-1.02.76-1.5,1.17,0,0,0,0,0,0h0c-4.23,3.62-7.08,8.8-7.62,14.67-.07.67-.1,1.35-.1,2.04s.04,1.37.1,2.04c.6,6.53,4.07,12.22,9.12,15.84.03.02.06.05.09.07.53.37,1.07.72,1.63,1.05.02,0,.03.02.05.03,3.24,1.87,6.98,2.96,10.99,2.96s7.75-1.09,10.99-2.96c.02,0,.03-.02.05-.03.56-.33,1.1-.67,1.63-1.04.03-.02.06-.05.09-.07.52-.37,1.02-.76,1.5-1.17,0,0,0,0,0,0h0c4.23-3.62,7.08-8.8,7.62-14.67ZM501.79,219.4c-5.55,1.55-10.06,1.21-11.52-1.32-1.46-2.54.5-6.62,4.62-10.65,3.57,2.99,6.07,7.19,6.9,11.98ZM488.93,204c-1.43,5.58-3.98,9.32-6.91,9.32s-5.48-3.74-6.91-9.32c2.16-.79,4.48-1.25,6.91-1.25s4.75.45,6.91,1.25ZM469.15,207.43c4.13,4.03,6.09,8.12,4.62,10.65-1.46,2.53-5.98,2.88-11.52,1.32.83-4.78,3.33-8.99,6.9-11.98ZM462.25,226.28c5.55-1.55,10.06-1.21,11.52,1.32,1.46,2.54-.5,6.62-4.62,10.65-3.57-2.99-6.07-7.19-6.9-11.98ZM475.11,241.68c1.43-5.58,3.98-9.32,6.91-9.32s5.48,3.74,6.91,9.32c-2.16.79-4.48,1.25-6.91,1.25s-4.75-.45-6.91-1.25ZM490.27,227.6c1.46-2.53,5.98-2.88,11.52-1.32-.83,4.78-3.33,8.99-6.9,11.98-4.13-4.03-6.09-8.12-4.62-10.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 482.02,
    cy: 222.84,
    r: 7.92,
    transform: "translate(-11.59 27) rotate(-3.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M487.62,222.84c0,3.09-2.51,5.6-5.6,5.6s-5.6-2.51-5.6-5.6,2.51-5.6,5.6-5.6,5.6,2.51,5.6,5.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 482.02,
    cy: 222.84,
    r: 4.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M85.54,115.45h0c-1.22.59-2.7.08-3.29-1.13l-11.85-24.29c-.59-1.22-.08-2.7,1.13-3.29h0c1.22-.59,2.7-.08,3.29,1.13l11.85,24.29c.59,1.22.08,2.7-1.13,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M165.64,82.47c1.16-1.23,1.85-2.91,1.76-4.73l-.63-12.22c-.18-3.53-3.22-6.27-6.76-6.09h-.21c-3.53.19-6.27,3.23-6.09,6.77l.63,12.22c.1,1.83.97,3.44,2.27,4.55-2.68,1.43-4.75,3.98-5.45,7.16l-7.8,35.53c-1.27,5.77,2.42,11.53,8.19,12.79,5.77,1.27,11.53-2.42,12.79-8.19l7.8-35.53c1.14-5.18-1.73-10.35-6.5-12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M562.43,0H207.92C144.61,0,8.94,86.48,8.94,138.36v81.06l26.47,9.17h28.81c1.33-32.98,24.83-59.24,53.63-59.24s52.3,26.27,53.63,59.24h256.91c1.33-32.98,24.83-59.24,53.63-59.24s52.3,26.27,53.63,59.24h19.6c5.68,0,11.35-.51,16.94-1.54l26.24-4.25c3.13-.51,5.44-3.21,5.44-6.39v-11.48c0-1.35-.84-2.56-2.1-3.03l-1.52-.57v-74.71c0-75.53-29.89-126.62-37.81-126.62ZM164.21,95.91c-1.62,4.9-6.07,8.31-11.23,8.61l-105.39,6.14c-15.08,0,45.44-63.86,72.34-65.47l52.03-.61c7.36,0-2.35,35.04-7.75,51.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M548.34,219.41c0-36.63-29.69-66.32-66.32-66.32s-66.32,29.69-66.32,66.32c0,3.59.32,5.73.87,9.17l13.51,1.38c1.15-31.82,23.96-57.22,51.94-57.22s50.79,25.4,51.94,57.22l13.51-1.38c.55-3.44.87-5.58.87-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M482.02,156.09c21.92,0,41.4,9.66,53.85,24.64-12.04-16.73-31.67-27.63-53.85-27.63s-41.81,10.9-53.85,27.63c12.44-14.98,31.93-24.64,53.85-24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M184.17,219.41c0-36.63-29.69-66.32-66.32-66.32s-66.32,29.69-66.32,66.32c0,3.59.32,5.73.87,9.17l13.51,1.38c1.15-31.82,23.96-57.22,51.94-57.22s50.79,25.4,51.94,57.22l13.51-1.38c.55-3.44.87-5.58.87-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M117.85,156.09c21.92,0,41.4,9.66,53.85,24.64-12.04-16.73-31.67-27.63-53.85-27.63s-41.81,10.9-53.85,27.63c12.44-14.98,31.93-24.64,53.85-24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M183.82,207.72c16.78-3.87,44.56-6.39,76.73-6.39h177.12c.62-1.17,1.26-2.31,1.95-3.42h-167.96c-40.91,0-74.75,4.08-87.85,9.81ZM524.42,197.91c.69,1.11,1.33,2.26,1.95,3.42h73.87v-3.42h-75.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "580.41 225.71 579.3 225.89 579.3 201.33 580.41 201.33 580.41 225.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266.86,132.61c-87.11,0-159.15,5.38-187.03,12.93,35.73-5.09,94.88-8.42,163.37-8.42h352.4v-4.51h-328.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M601.77,201.9l-1.52-.57v-74.71c0-75.53-29.89-126.62-37.81-126.62H207.92C144.61,0,8.94,86.48,8.94,138.36v22.42H2.92c-1.61,0-2.92,1.59-2.92,3.56v43.04c0,8.49,4.89,15.81,11.71,17.51l23.7,3.69h16.99l13.51,1.38c1.15-31.82,23.96-57.22,51.94-57.22s50.79,25.4,51.94,57.22l13.51-1.38h233.27l13.51,1.38c.38-10.47,3.11-20.23,7.59-28.63h0c.62-1.16,1.26-2.31,1.95-3.42,9.42-15.23,24.9-25.17,42.4-25.17s32.98,9.94,42.4,25.17c.69,1.11,1.33,2.26,1.95,3.42h0c4.48,8.4,7.21,18.17,7.59,28.63l13.51-1.38h7.78c5.68,0,11.35-.51,16.94-1.54l26.24-4.25c3.13-.51,5.44-3.21,5.44-6.39v-11.48c0-1.35-.84-2.56-2.1-3.03ZM119.93,45.2l52.03-.61c7.36,0-2.35,35.04-7.75,51.32-1.62,4.9-6.07,8.31-11.23,8.61l-105.39,6.14c-15.08,0,45.44-63.86,72.34-65.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.21,95.91c-1.62,4.9-6.07,8.31-11.23,8.61l-105.39,6.14c-15.08,0,45.44-63.86,72.34-65.47l52.03-.6c7.36,0-2.35,35.04-7.75,51.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M174.28,44.96c-.58-.8-1.38-1.22-2.33-1.22l-52.07.61c-10.62.63-28.21,11.27-47.03,28.46-14.3,13.06-28.68,29.59-28.49,35.91.05,1.79,1.23,2.81,3.28,2.81h0l105.39-6.14c5.54-.32,10.24-3.93,11.99-9.2.59-1.79,14.49-43.99,9.26-51.23ZM163.4,95.65c-1.52,4.6-5.63,7.75-10.47,8.03l-92.11,5.36v-21.88c16.52-18,43.06-40.15,59.12-41.11l52.02-.61c.39,0,.68.16.93.51,3.48,4.82-3.98,33.04-9.5,49.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M177.02,171.73h-7.33c-2.29,0-4.15-1.86-4.15-4.15v-8.84c0-2.29,1.86-4.15,4.15-4.15h12.87c2.29,0,4.15,1.86,4.15,4.15v3.3c0,5.34-4.35,9.69-9.69,9.69ZM169.69,154.95c-2.09,0-3.79,1.7-3.79,3.79v8.84c0,2.09,1.7,3.78,3.79,3.78h7.33c5.14,0,9.33-4.18,9.33-9.33v-3.3c0-2.09-1.7-3.79-3.79-3.79h-12.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 141.66,
    y: 113.1,
    width: 16.58,
    height: 12.02,
    rx: 5.9,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 142.52,
    y: 113.73,
    width: 14.86,
    height: 10.77,
    rx: 5.29,
    ry: 5.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 138.06,
    y: 116.1,
    width: 23.3,
    height: 6.03,
    rx: 1.54,
    ry: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 201.93,
    y: 113.36,
    width: 16.58,
    height: 12.02,
    rx: 3.55,
    ry: 3.55,
    transform: "translate(90.85 329.59) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M205.73,113.98h8.99c1.62,0,2.94,1.32,2.94,2.94v4.9c0,1.62-1.32,2.94-2.94,2.94h-8.99c-1.62,0-2.94-1.32-2.94-2.94v-4.9c0-1.62,1.32-2.94,2.94-2.94Z",
    transform: "translate(90.85 329.59) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.02,116.36h12.4c.68,0,1.23.55,1.23,1.23v4.8h-14.86v-4.8c0-.68.55-1.23,1.23-1.23Z",
    transform: "translate(90.85 329.59) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M106.53,40.11h-6.8c-33.19,20.2-63.52,45.24-79.33,68.33h3.48c2.03,0,3.95-.94,5.14-2.58,16.24-22.37,45.55-46.3,77.5-65.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M13.6,143.71c-.14,0-.25-.11-.26-.25-.35-20.57,13.01-37.27,13.15-37.44.09-.11.25-.13.36-.04.11.09.13.25.04.36-.13.16-13.38,16.73-13.03,37.1,0,.14-.11.26-.25.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M8.94,138.63h12.8c4.78,0,8.67,3.88,8.67,8.67v12.8H8.94v-21.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M8.94,139.82h12.1c4.52,0,8.19,3.67,8.19,8.19v12.1H8.94v-20.29h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 9.44,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(20.83 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 9.92,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(21.14 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 12.04,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(26.03 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 12.52,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(26.34 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 14.64,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(31.23 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 15.12,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(31.54 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 17.24,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(36.43 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 17.72,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(36.74 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 19.84,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(41.63 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 20.32,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(41.94 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 22.44,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(46.83 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 22.92,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(47.14 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 25.04,
    y: 146.79,
    width: 1.95,
    height: 7.14,
    rx: 0.53,
    ry: 0.53,
    transform: "translate(52.03 300.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 25.52,
    y: 147,
    width: 1.3,
    height: 4.76,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(52.34 298.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 9.44,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(19.84 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 9.67,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(19.99 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 10.72,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(22.39 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 10.95,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(22.54 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 11.99,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(24.93 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 12.22,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(25.08 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 13.26,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(27.48 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 13.5,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(27.63 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 14.54,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(30.03 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 14.77,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(30.18 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 15.81,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(32.58 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 16.05,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(32.73 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 17.09,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(35.13 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 17.32,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(35.28 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 18.39,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(37.73 313.28) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 18.62,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(37.88 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 19.66,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(40.28 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 19.9,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(40.43 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 20.94,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(42.83 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 21.17,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(42.98 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 22.21,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(45.38 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 22.44,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(45.53 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 23.49,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(47.93 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 23.72,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(48.08 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 24.76,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(50.47 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 24.99,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(50.62 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 26.03,
    y: 154.37,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(53.02 313.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 26.27,
    y: 154.5,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(53.17 312.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 9.44,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(19.84 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 9.67,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(19.99 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 10.72,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(22.39 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 10.95,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(22.54 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 11.99,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(24.93 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 12.22,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(25.08 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 13.26,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(27.48 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 13.5,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(27.63 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 14.54,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(30.03 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 14.77,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(30.18 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 15.81,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(32.58 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 16.05,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(32.73 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 17.09,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(35.13 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 17.32,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(35.28 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 18.39,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(37.73 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 18.62,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(37.88 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 19.66,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(40.28 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 19.9,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(40.43 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 20.94,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(42.83 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 21.17,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(42.98 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 22.21,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(45.38 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 22.44,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(45.53 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 23.49,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(47.93 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 23.72,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(48.08 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 24.76,
    y: 141.81,
    width: 0.96,
    height: 4.54,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(50.47 288.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 24.99,
    y: 141.94,
    width: 0.64,
    height: 3.03,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(50.62 286.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M75.45,197.91h-40.04v2.44c0,3,2.44,5.44,5.44,5.44h30.49c1.2-2.75,2.57-5.39,4.11-7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M79.83,145.55c35.73-3.86,94.88-6.39,163.37-6.39h352.4v-2.03H243.2c-68.49,0-127.64,3.33-163.37,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M586.76,121.56v52.56c0,4.01,3.25,7.27,7.27,7.27h6.22v-54.77c0-4.19-.11-8.29-.28-12.33h-5.94c-4.01,0-7.27,3.25-7.27,7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M595.52,179.68h4.72v-53.06c0-3.6-.09-7.13-.22-10.62h-4.5c-4.01,0-7.27,3.09-7.27,6.9v49.88c0,3.81,3.25,6.9,7.27,6.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 596.77,
    y: 119.29,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 597.02,
    y: 119.69,
    width: 1.88,
    height: 9.04,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 593.23,
    y: 119.29,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M594.07,119.69h.7c.33,0,.59.26.59.59v7.85c0,.33-.26.59-.59.59h-.7c-.33,0-.59-.26-.59-.59v-7.85c0-.33.26-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 589.69,
    y: 119.29,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 589.94,
    y: 119.69,
    width: 1.88,
    height: 9.04,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 596.77,
    y: 133.55,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 597.02,
    y: 133.95,
    width: 1.88,
    height: 9.04,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 593.23,
    y: 133.55,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M594.07,133.95h.7c.33,0,.59.26.59.59v7.85c0,.33-.26.59-.59.59h-.7c-.33,0-.59-.26-.59-.59v-7.85c0-.33.26-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 589.69,
    y: 133.55,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 589.94,
    y: 133.95,
    width: 1.88,
    height: 9.04,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 596.77,
    y: 147.81,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M597.61,148.21h.7c.33,0,.59.26.59.59v7.85c0,.33-.26.59-.59.59h-.7c-.33,0-.59-.26-.59-.59v-7.85c0-.33.26-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 593.23,
    y: 147.81,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M594.07,148.21h.7c.33,0,.59.26.59.59v7.85c0,.33-.26.59-.59.59h-.7c-.33,0-.59-.26-.59-.59v-7.85c0-.33.26-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 589.69,
    y: 147.81,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M590.53,148.21h.7c.33,0,.59.26.59.59v7.85c0,.33-.26.59-.59.59h-.7c-.33,0-.59-.26-.59-.59v-7.85c0-.33.26-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 596.77,
    y: 162.06,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 597.02,
    y: 162.47,
    width: 1.88,
    height: 9.04,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 593.23,
    y: 162.06,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M594.07,162.47h.7c.33,0,.59.26.59.59v7.85c0,.33-.26.59-.59.59h-.7c-.33,0-.59-.26-.59-.59v-7.85c0-.33.26-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 589.69,
    y: 162.06,
    width: 2.82,
    height: 13.55,
    rx: 0.89,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 589.94,
    y: 162.47,
    width: 1.88,
    height: 9.04,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M594.07,160.78h6.17v12.41h-6.17c-1.83,0-3.32-1.49-3.32-3.32v-5.78c0-1.83,1.49-3.32,3.32-3.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 591.55,
    y: 162.27,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1184.4 333.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 591.87,
    y: 162.55,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1184.61 331.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 593.29,
    y: 162.27,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1187.87 333.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M593.92,162.55h.23c.18,0,.32.14.32.32v5.66c0,.18-.14.32-.32.32h-.23c-.18,0-.32-.14-.32-.32v-5.66c0-.18.14-.32.32-.32Z",
    transform: "translate(1188.08 331.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 595.02,
    y: 162.27,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1191.34 333.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 595.34,
    y: 162.55,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1191.55 331.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 596.76,
    y: 162.27,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1194.81 333.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 597.07,
    y: 162.55,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1195.01 331.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 598.49,
    y: 162.27,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1198.28 333.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 598.81,
    y: 162.55,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1198.48 331.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M594.07,144.31h6.17v12.41h-6.17c-1.83,0-3.32-1.49-3.32-3.32v-5.78c0-1.83,1.49-3.32,3.32-3.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 591.55,
    y: 145.79,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1184.4 301.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 591.87,
    y: 146.07,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1184.61 298.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 593.29,
    y: 145.79,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1187.87 301.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 593.61,
    y: 146.07,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1188.08 298.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 595.02,
    y: 145.79,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1191.34 301.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 595.34,
    y: 146.07,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1191.55 298.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 596.76,
    y: 145.79,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1194.81 301.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 597.07,
    y: 146.07,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1195.01 298.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 598.49,
    y: 145.79,
    width: 1.3,
    height: 9.44,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1198.28 301.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 598.81,
    y: 146.07,
    width: 0.87,
    height: 6.29,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1198.48 298.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 357.84,
    y: 135.39,
    width: 131.09,
    height: 2.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M107.16,40.61h-7.72c-.35,0-.64-.29-.64-.64s.29-.64.64-.64h7.72c5.65,0,14.21-4.92,23.27-10.13,10.37-5.96,21.09-12.12,29.34-12.12h415.53c.35,0,.64.29.64.64s-.29.64-.64.64H159.78c-7.91,0-18.48,6.08-28.7,11.95-9.21,5.3-17.92,10.3-23.91,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M295.45,27.27c-79.24,0-144.78,4.03-170.14,9.7,32.5-3.82,86.31-6.32,148.62-6.32h300.28c.97,0,1.75-.76,1.75-1.69h0c0-.93-.78-1.69-1.75-1.69h-278.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M358.1,225.28h-163.61c-.15,0-.27-.12-.27-.27V18.36c0-.15.12-.27.27-.27s.27.12.27.27v206.39h163.08V18.36c0-.15.12-.27.27-.27s.27.12.27.27v206.66c0,.15-.12.27-.27.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M146.13,182.36c.34.25.67.52,1.01.78,7.57-8.71,20.75-34.81,23.84-43.39,2.98-8.31,16.25-95.07,12.9-99.83-.27-.39-.62-.45-.8-.45-.52,0-1.65-.04-3.29-.09-11.27-.36-45.56-1.46-68.94,2.95-18.44,3.48-75.44,54.85-75.44,71.96v114.29h1.28v-114.29c0-16.2,56.81-67.38,74.4-70.7,23.24-4.38,57.42-3.29,68.66-2.93,1.48.05,2.55.08,3.14.09,2.49,4.85-9.9,89.6-13.12,98.56-3.07,8.55-16.22,34.61-23.64,43.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M565.38,41.01H208.16c-3.43,0-5.85,3.38-4.74,6.63,0,0,17.53,60.99,46.33,60.99h325.16c6,0,10.7-5.19,10.11-11.16-1.87-18.88-5.58-35.54-9.95-49.36-1.34-4.23-5.25-7.11-9.69-7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M216.6,46.55c-2.87,0-4.89,2.82-3.97,5.54,0,0,14.66,51.01,38.74,51.01h94.22c2.21,0,4-1.79,4-4v-48.54c0-2.21-1.79-4-4-4h-128.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M576.8,93.72c-1.56-15.75-4.66-29.65-8.3-41.18-1.12-3.56-4.39-5.99-8.12-5.99h-190.63c-2.21,0-4,1.79-4,4v48.54c0,2.21,1.79,4,4,4h198.6c5.04,0,8.95-4.36,8.45-9.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M345.59,103.95h-94.22c-24.45,0-38.96-49.52-39.56-51.63-.52-1.52-.27-3.18.69-4.52.96-1.34,2.46-2.11,4.1-2.11h128.99c2.68,0,4.86,2.18,4.86,4.86v48.54c0,2.68-2.18,4.86-4.86,4.86ZM216.6,47.41c-1.09,0-2.08.51-2.71,1.39-.64.89-.8,1.98-.45,3.02.16.54,14.77,50.43,37.93,50.43h94.22c1.74,0,3.15-1.41,3.15-3.15v-48.54c0-1.74-1.41-3.15-3.15-3.15h-128.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M568.35,103.95h-198.6c-2.68,0-4.86-2.18-4.86-4.86v-48.54c0-2.68,2.18-4.86,4.86-4.86h190.63c4.1,0,7.69,2.65,8.94,6.59,4.1,12.97,6.9,26.89,8.34,41.36,0,0,0,0,0,0,.26,2.64-.61,5.28-2.39,7.24-1.77,1.95-4.29,3.07-6.92,3.07ZM369.75,47.41c-1.73,0-3.15,1.41-3.15,3.15v48.54c0,1.74,1.41,3.15,3.15,3.15h198.6c2.18,0,4.19-.89,5.65-2.51,1.46-1.61,2.17-3.77,1.95-5.93h0c-1.42-14.35-4.2-28.15-8.27-41.01-1.02-3.22-3.95-5.39-7.3-5.39h-190.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M35.41,228.59l-23.7-3.69c-6.81-1.7-11.71-9.02-11.71-17.51v-43.04c0-1.97,1.31-3.56,2.92-3.56h32.49v67.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.41,205.79l-19.91-2.37c-5.72-1.09-9.83-5.78-9.83-11.21v-27.57c0-1.26,1.1-2.28,2.45-2.28h27.3v43.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M601.77,201.9l-1.52-.57h-19.84v24.39l18.03-2.92c3.13-.51,5.44-3.21,5.44-6.39v-11.48c0-1.35-.84-2.56-2.1-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M66.09,92.41s31.65-14.24,50.48-17.23c18.83-2.99,40.63.43,46.88-4.28,6.25-4.71,7.96-21.68,7.96-21.68,0,0-43.65-2-56.2,3.42-12.55,5.42-39.48,24.76-49.12,39.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M74.99,107.21h-19.39c-2.68,0-4.86-2.18-4.86-4.86h0c0-10.96,8.89-19.85,19.85-19.85h3.77c1.59,0,2.89,1.29,2.89,2.89v19.57c0,1.25-1.01,2.26-2.26,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M71.53,105.09h-16.75c-2.23,0-4.04-1.81-4.04-4.04h0c0-9.11,7.39-16.5,16.5-16.5h3.77c1.32,0,2.4,1.07,2.4,2.4v16.27c0,1.04-.84,1.88-1.88,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M299.07,77.63h-52.67c-10.29,0-19.68-5.84-24.24-15.06l-3.79-7.67c-.98-1.99.46-4.32,2.68-4.32h123.8c0,14.94-30.85,27.05-45.79,27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M507.53,77.63h-128.51c-4.53,0-8.21-3.68-8.21-8.21v-11.92c0-3.82,3.1-6.92,6.92-6.92h181.67c1.84,0,3.32,1.49,3.32,3.32h0c0,13.1-42.1,23.72-55.2,23.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiace);
export default __webpack_public_path__ + "static/media/Hiace.9f878423d6f8230208b4fd06fa711636.svg";
export { ForwardRef as ReactComponent };